import { faSparkles } from '@fortawesome/pro-regular-svg-icons'
import Typography from '@mui/material/Typography'
import { GradientFaIcon } from '@labrav/common'
import { REVIEW_WITH_AI_LABEL } from './constants'
import { useStyles } from './ReviewWithAiButton.styles'

interface ReviewWithAiButtonProps {
  onClick: () => void
}

export const ReviewWithAiButton = ({ onClick }: ReviewWithAiButtonProps) => {
  const { classes } = useStyles()
  return (
    <button
      type="button"
      className={classes.button}
      onClick={onClick}
      aria-label={REVIEW_WITH_AI_LABEL}
    >
      <GradientFaIcon icon={faSparkles} className={classes.icon} />
      <Typography component="span" className={classes.label}>
        {REVIEW_WITH_AI_LABEL}
      </Typography>
    </button>
  )
}
